var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserDefault({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b{fill:#1d252c;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1458 -578)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 30,
    height: 30,
    transform: "translate(1458 578)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M30-9.767v1.4a.646.646,0,0,1-.667.7.646.646,0,0,1-.667-.7v-1.4a2.015,2.015,0,0,0-2-2.1H21.333a2.015,2.015,0,0,0-2,2.1v1.4a.646.646,0,0,1-.667.7.646.646,0,0,1-.667-.7v-1.4a3.386,3.386,0,0,1,3.333-3.5h5.333A3.386,3.386,0,0,1,30-9.767Zm-9.333-8.4A3.386,3.386,0,0,1,24-21.667a3.386,3.386,0,0,1,3.333,3.5A3.386,3.386,0,0,1,24-14.667,3.386,3.386,0,0,1,20.667-18.167Zm1.333,0a2.015,2.015,0,0,0,2,2.1,2.015,2.015,0,0,0,2-2.1,2.015,2.015,0,0,0-2-2.1A2.015,2.015,0,0,0,22-18.167Z",
    transform: "translate(1448.999 607.666)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserDefault);
export default __webpack_public_path__ + "static/media/user-default.07ad0e3c12fca7bd69d893e50660fe73.svg";
export { ForwardRef as ReactComponent };